import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"
import { Checkbox, transformLinkUri } from "gatsby-theme-gba"

const CheckboxEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <Checkbox
      name={blok.name}
      label={
        <Markdown
          source={blok.label}
          linkTarget="_blank"
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        ></Markdown>
      }
      value={blok.value}
      placeholder={blok.placeholder}
      required={blok.required}
    />
  </SbEditable>
)

export default CheckboxEditable
